import { SubmitToSandboxSettingsFormView } from '../view/SubmitToSandboxSettingsFormView';
import { templateSubmitToSandboxSettingsForm } from '../view/template';
import { BaseWebComponentController, WebComponentEvent } from '../../../../../framework/BaseWebComponentController';
import { SubmitToSandboxSettingsFormWebComponent } from '..';
import { SubmitToSandboxSettingsFormWebComponentSchema } from '../types';

export class SubmitToSandboxSettingsFormController extends BaseWebComponentController {
  public component: SubmitToSandboxSettingsFormWebComponent;
  public view: SubmitToSandboxSettingsFormView;
  public viewConstructor: typeof SubmitToSandboxSettingsFormView;

  constructor(component: SubmitToSandboxSettingsFormWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: SubmitToSandboxSettingsFormView,
      viewTemplate: templateSubmitToSandboxSettingsForm,
    });
  }

  async getDataForView(): Promise<SubmitToSandboxSettingsFormWebComponentSchema> {
    return {};
  }
}
